export default {
  packageConfigsList: 'Package configs list',
  packageConfigsCreate: 'Create package config',
  agencyPackageConfigsList: 'Agency package configs list',
  agencyPackageConfigsCreate: 'Create',
  agencyPackageConfigsIncrease: 'Extend',
  agencyPackageConfigsBuy: 'Buy',
  agencyPackageConfigsEdit: 'Edit',
  total: 'Total',
  packageDetails: 'Package details',
  packageUsageDetails: ' Package usage details',
  clearFilters: ' Clear filters',
  domainSettings: 'Domain settings',
  agencyPackageConfigsGift: 'Gift',
  over: 'Exceeded limit',
  notover: ' Remaining limit',
  all: 'All',
  usageDetails: 'Usage details',
  detail: 'Detail',
  discountBy: 'Discount by',
  delete: 'Delete',
  Unused: 'Unused',
  agencyPackageOrderList: 'Order list',
  agCreate: {
    title: 'Create',
  },
  columns: {
    name: 'Name',
    type: 'Type',
    price: 'Price',
    searchLimit: 'Search limit',
    specialNote: 'Note',
    bookingLimit: 'Booking limit',
    issueLimit: 'Issue limit',
    paxLimit: 'Pax limit',
    enableQR: 'Enable QR',
    unit: 'Unit',
    enableFilter: 'Enable filter',
    feeTransaction: 'Fee transaction',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    isActive: 'Status',
    agency: 'Agency',
    parentAgency: 'Agency F2',
    packageConfig: 'Package config',
    packageConfigIssueLimit: 'Package config issue limit',

    monthsUse: 'Months use',
    monthsExtra: 'Months extra',
    expiredAt: 'Expired at',
    enable: 'Enable',
    action: 'Action',
    paymentMethod: 'Payment method',
    payment: 'Payment',
    buyer: 'Buyer',
    agencyRetail: 'Agency retail',
    orderCode: 'Order code',
    totalAmountToBePaid: 'Total amount to be paid',
    totalPrice: 'Total price',
    searchCount: 'Search count',
    issueCount: 'Issue count',
    bookCount: 'Book count',
    periodStart: 'Start date',
    periodEnd: 'End date',
    percentage: 'Percentage (%)',
    amountMax: 'Amount max',
    code: 'Code',
    isUsed: 'Used',
    totalDiscount: 'Discount',
    autoIssueTicket: 'Auto issue ticket',
    enableDraft: 'Enable draft booking',
    domain: 'domain',
    isExpired: 'Expired',
    dateCreate: 'Date',
    paymentMethods: 'Payment methods',
  },
  placeholder: {
    searchText: 'Search package config',
    agency: 'Agency',
  },
  buy: {
    title: 'Buy package config',
  },
  increase: {
    title: 'Extend package config',
  },
  payment: {
    title: 'Payment',
  },
  gift: {
    title: 'Gift package config',
  },
  CREDIT: 'Credit',
  MONEY: 'Money',
  PENDING: 'Pending',
  DONE: 'Done',
  CANCELED: 'Cancel',
  cancel: 'Cancel',
  CANCEL: 'Cancel',
  coupon: {
    titleList: 'Package Coupons List',
    create: 'Create',
    createCoupon: 'Create coupon',
  },
  addDomain: 'Add domain',
  expired: 'Expired',
  unexpired: 'Unexpired',
  history: {
    title: 'History',
  },
  form: {
    create: 'Create package',
    update: 'Update package',
    name: 'Name',
    price: 'Price',
    unit: 'Unit',
    searchLimit: 'Search limit',
    bookingLimit: 'Booking limit',
    issueLimit: 'Issue limit',
    invoiceIssueLimit: 'Invoice issue limit',
    paxLimit: 'Pax limit',
    enableQR: 'Enable QR',
    enableFilter: 'Enable filter',
    feeTransaction: 'Transaction fee',
    feeTransactionInvoice: 'Invoice transaction fee',
    isGift: 'Is gift',
    type: 'Type',
    exclusiveAgencies: 'Exclusive agencies',
    descriptions: 'Descriptions',
    paymentMethods: 'Payment methods',
    placeholder: {
      name: 'Enter name',
      price: 'Enter price',
      unit: 'Enter unit',
      searchLimit: 'Enter search limit',
      bookingLimit: 'Enter booking limit',
      issueLimit: 'Enter issue limit',
      invoiceIssueLimit: 'Enter invoice issue limit',
      paxLimit: 'Enter pax limit',
      enableQR: 'Enable QR',
      enableFilter: 'Enable filter',
      feeTransaction: 'Enter transaction fee',
      feeTransactionInvoice: 'Enter invoice transaction fee',
      isGift: 'Select if gift',
      type: 'Select if type',
      exclusiveAgencies: 'Enter exclusive agencies',
      descriptions: 'Enter descriptions',
    },
    key: 'Key',
    description: 'Description',
    value: 'Value',
  },
  units: {
    MONTH: 'Month',
    YEAR: 'Year',
    PACKAGE: 'Package',
  },
  btn: {
    addDescription: 'Add description',
  },
  noPeriod: 'No period',
  giftPackage: {
    multiLegSearch: 'Multi-leg search',
    searchBookInternationalFlightsQRPayment: 'Search and book international flights',
    QRPayment: 'QR payment',
    supportManagingVirtualBookings: 'Support for managing virtual bookings',
    automaticTicketIssuanceUponPayment: 'Automatic ticket issuance upon payment',
    banUnbanIndividualClientSuspiciousActivity: 'Ban/Unban IPs of individual clients with suspicious activity',
    lookupBookedHeldFlightsOrders: 'Lookup booked/held flights or orders',
    manageReportsAndReceivables: 'Manage reports and receivables',
    manageListBookedTickets: 'Manage list of booked tickets',
    professionalTicketManagementSystemAgents: 'Professional ticket management system for agents',
    sendOrderConfirmationPaymentConfirmationEmails: 'Send order confirmation/payment confirmation emails',
    manageServiceDeesTicketIssuanceFeesConfiguration: 'Manage service fees/ticket issuance fees configuration',
    manageInvoiceRequestInformationVAT: 'Manage invoice request information for VAT',
    showNearbyDates: 'Show nearby dates',
    flightFiltersSortingOptions: 'Flight filters and sorting options',
    searchAndBookDomesticFlights: 'Search and book domestic flights',
  },
  willExpireCountDayBeforeExpiredDays: ' Will expire in {countDayBeforeExpired} days',
  expiredCountDayBeforeExpiredDaysAgo: 'Expired {countDayBeforeExpired} days ago',
}
